import { render, staticRenderFns } from "./firsthome.vue?vue&type=template&id=4f2a0fac"
import script from "./firsthome.vue?vue&type=script&lang=js"
export * from "./firsthome.vue?vue&type=script&lang=js"
import style0 from "./firsthome.vue?vue&type=style&index=0&id=4f2a0fac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports